import { useQuery } from "@tanstack/react-query";
import { getMessagesByGameId } from "../../../api";
import { useCurrentGameId } from "./use-current-game";

export function useCurrentMessages() {
  const gameId = useCurrentGameId();

  return useQuery({
    queryKey: ["games", gameId, "messages"],
    queryFn: async () => {
      return await getMessagesByGameId(gameId);
    },
    enabled: !!gameId,
  });
}
